export default __webpack_public_path__ + "static/media/individual-banner-update.bcc904d3.png";